import React, { useEffect, useState } from "react";
import { Pagination } from "antd";
import { useSearchParams } from "react-router-dom";
import { useUserContext } from "../../context/dashboard-context";

const CustomPagination = ({
  total = 0,
  current = 1,
  setCurrentPage = () => {}, // Provide default function
  pageSize = 12, // Changed to match your usage
  func = () => {}, // Provide default function
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const page = parseInt(searchParams.get("page")) || current;
    setCurrentPage(page);
  }, [searchParams, current, setCurrentPage]);

  const onPageChange = (page) => {
    setCurrentPage(page);
    searchParams.set("page", page);
    setSearchParams(searchParams);
    func(page);
  };

  return (
    <Pagination
      current={current}
      pageSize={pageSize}
      total={total}
      onChange={onPageChange}
      showSizeChanger={false} // Added to match your previous implementation
    />
  );
};

export default CustomPagination;